export enum WorkflowStepStatus {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2,
  Blocked = 4,
}

export const workflowStepInformation = {
  [WorkflowStepStatus.NotStarted]: {
    id: WorkflowStepStatus.NotStarted,
    name: "Not Started",
    allowedStateTransitions: [
      WorkflowStepStatus.NotStarted,
      WorkflowStepStatus.InProgress,
      WorkflowStepStatus.Completed,
      WorkflowStepStatus.Blocked,
    ],
  },
  [WorkflowStepStatus.InProgress]: {
    id: WorkflowStepStatus.InProgress,
    name: "In Progress",
    allowedStateTransitions: [
      WorkflowStepStatus.InProgress,
      WorkflowStepStatus.Completed,
      WorkflowStepStatus.Blocked,
    ],
  },
  [WorkflowStepStatus.Completed]: {
    id: WorkflowStepStatus.Completed,
    name: "Completed",
    allowedStateTransitions: [
      WorkflowStepStatus.Completed,
      WorkflowStepStatus.InProgress,
      WorkflowStepStatus.Blocked,
    ],
  },
  [WorkflowStepStatus.Blocked]: {
    id: WorkflowStepStatus.Blocked,
    name: "Blocked",
    allowedStateTransitions: [
      WorkflowStepStatus.Blocked,
      WorkflowStepStatus.InProgress,
      WorkflowStepStatus.Completed,
    ],
  },
};
